var map = {
	"./assets/clickable/bbb.svg": "6a3916b9cde97146168b",
	"./assets/disabled/bbb.svg": "3fe792ae89c691eade6a",
	"./assets/original/bbb.svg": "0a2ef9816c6019b35073"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e94bcc6485e23404c9c";